import { useEffect } from "react";

export type Props = {
  page: number;
  pages: number;
  onPageChange: (page: number) => void;
};

const Pagination = ({ page, pages, onPageChange }: Props) => {
  useEffect(() => {
    const topPosition = window.innerWidth <= 768 ? 700 : 180;
    window.scrollTo({ top: topPosition, behavior: "smooth" });
  }, [page]);

  const getPageNumbers = () => {
    const visiblePages: (number | "...")[] = [];

    if (pages <= 5) {
      return Array.from({ length: pages }, (_, i) => i + 1);
    }

    visiblePages.push(1); // Always show the first page

    if (page > 3) {
      visiblePages.push("...");
    }

    const start = Math.max(2, page - 1);
    const end = Math.min(pages - 1, page + 1);

    for (let i = start; i <= end; i++) {
      visiblePages.push(i);
    }

    if (page < pages - 2) {
      visiblePages.push("...");
    }

    visiblePages.push(pages); // Always show the last page

    return visiblePages;
  };

  return (
    <div className="flex justify-center mt-4 overflow-x-auto whitespace-nowrap">
  <ul className="flex items-center space-x-1 md:space-x-2">
    {/* Prev Button */}
    <li>
      <button
        onClick={() => page > 1 && onPageChange(page - 1)}
        disabled={page === 1}
        className="px-2 py-1 text-sm md:px-3 md:py-1 md:text-sm font-medium text-gray-500 bg-white border border-slate-300 rounded-md hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Prev
      </button>
    </li>

    {/* Page Numbers */}
    {getPageNumbers().map((number, index) => (
      <li key={index}>
        {number === "..." ? (
          <span className="px-2 py-1 text-xs md:px-3 md:py-1 md:text-sm text-gray-500">...</span>
        ) : (
          <button
            onClick={() => onPageChange(number as number)}
            className={`px-2 py-1 text-xs md:px-3 md:py-1 md:text-sm font-medium border rounded-md transition-colors duration-300 ${
              page === number
                ? "bg-halo-pink text-white border-halo-pink"
                : "bg-white text-gray-500 border-slate-300 hover:bg-gray-100"
            }`}
          >
            {number}
          </button>
        )}
      </li>
    ))}

    {/* Next Button */}
    <li>
      <button
        onClick={() => page < pages && onPageChange(page + 1)}
        disabled={page === pages}
        className="px-2 py-1 text-xs md:px-3 md:py-1 md:text-sm font-medium text-gray-500 bg-white border border-slate-300 rounded-md hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Next
      </button>
    </li>
  </ul>
</div>

  );
};

export default Pagination;
